import { Col, Row } from "antd";
import HistoryBalanceSection from "../components/Sections/HistoryBalanceSection";
import { useUser } from "../context/UserContext";
import { hasRoleAccess } from "../utils/constants";

const HistoryBalance = () => {
  const { roles } = useUser();

  if (!hasRoleAccess(roles, ["ADMIN", "HR"])) {
    return null;
  }

  return (
    <Row>
      <Col xs={24}>
        <HistoryBalanceSection />
      </Col>
    </Row>
  );
};

export default HistoryBalance;
